module.exports = __webpack_public_path__ + "static/img/jt2.a755854e.png";